export default __webpack_public_path__ + "media/src/assets/images/warehouse-3aaf0ed06a5c50087c4b0c4fa3337ec6.png";